import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import promoColors from 'theme/promoColors';
import promoMedia from 'theme/promoMedia';

const Illustration = styled.figure`
    align-items: center;
    display: inline-flex;
    justify-content: center;
    margin: 0;
    min-width: 40px;
    padding: 0;
    width: 40px;
    height: 40px;

    img {
        border: none;
        max-width: 100%;
        max-height: 100%;
        vertical-align: top;
    }

    ${promoMedia.desktop1440} {
        height: 60px;
        width: 60px;
    }
`;
const TopIconWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const TopIcon = styled.figure`
    margin-bottom: 14px;
    padding: 0 24px 24px 24px;
    text-align: center;
    display: inline-block;
    border-bottom: 2px solid ${promoColors.gray5};
    width: 98px;
    height: 40px;

    ${Illustration} {
        width: auto;
    }

    img {
        max-width: 100%;
        max-height: 100%;
    }

    ${promoMedia.tablet744} {
        margin-bottom: 22px;
        padding: 0 24px 32px 24px;
    }

    ${promoMedia.desktop1440} {
        height: auto;
        width: auto;
        margin-bottom: 48px;
        padding: 0 0 64px 0;
    }
`;
const PaymentSystems = styled.ul`
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    list-style-type: none;
    margin: 0 auto 32px;
    padding: 0;
    max-width: 328px;

    & > li {
        align-items: center;
        display: inline-flex;
        justify-content: center;
        width: 40px;
        height: 40px;
        padding: 10px 0;
        flex-shrink: 0;
        margin: 0 12px;

        ${promoMedia.tablet744} {
            margin: 0 30px;
        }

        ${promoMedia.desktop1440} {
            width: 60px;
            height: 60px;
            padding: 16px 0;
        }
    }

    ${promoMedia.tablet744} {
        margin-bottom: 48px;
        max-width: 100%;
    }

    ${promoMedia.desktop1440} {
        max-width: 704px;
        margin-bottom: 64px;
    }
`;
export const PaymentSystemLogos = (props) => {
    return (
        <>
            {props.topIcon && (
                <TopIconWrap>
                    <TopIcon>
                        {Array.isArray(props.topIcon) &&
                            props.topIcon
                                .filter((item) => item !== null)
                                .map((item) => {
                                    return (
                                        <React.Fragment key={item.id}>
                                            <img
                                                alt={item.alternativeText}
                                                src={item.url}
                                                width="146"
                                                height="60"
                                                loading={props.loadingLazy ? 'lazy' : null}
                                                decoding={props.loadingLazy ? 'async' : null}
                                            />
                                        </React.Fragment>
                                    );
                                })}
                    </TopIcon>
                </TopIconWrap>
            )}
            <PaymentSystems>
                {Array.isArray(props.logos) &&
                    props.logos
                        .filter((item) => item !== null)
                        .map((item) => {
                            return (
                                <li key={item.id}>
                                    <Illustration>
                                        <img
                                            alt={item.alternativeText}
                                            src={item.url}
                                            width="60"
                                            height="60"
                                            loading={props.loadingLazy ? 'lazy' : null}
                                            decoding={props.loadingLazy ? 'async' : null}
                                        />
                                    </Illustration>
                                </li>
                            );
                        })}
            </PaymentSystems>
        </>
    );
};

PaymentSystemLogos.propTypes = {
    logos: PropTypes.array,
    topIcon: PropTypes.array,
    loadingLazy: PropTypes.bool,
};
